import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowTriangleTop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-triangle-top" maskId="round-filled-radius-0-stroke-1.5-IconArrowTriangleTop"><path d="M4.07918 18.9146C3.96293 19.1471 3.97536 19.4232 4.11201 19.6443C4.24867 19.8654 4.49007 20 4.75 20H19.25C19.5099 20 19.7513 19.8654 19.888 19.6443C20.0246 19.4232 20.0371 19.1471 19.9208 18.9146L12.6708 4.41459C12.5438 4.1605 12.2841 4 12 4C11.7159 4 11.4562 4.1605 11.3292 4.41459L4.07918 18.9146Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowTriangleTop;
